import { useCallback, useState} from 'react'
import kutirLogo from 'assets/images/kutirLogo.png'
import { useKeycloak } from '@react-keycloak/web'

interface LoginScreenProps {
  onLoginSuccess: () => void;
}
export function LoginScreen({ onLoginSuccess }: LoginScreenProps) {
  const { keycloak } = useKeycloak();
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  const openKeycloakPopup = (keycloak: any): Promise<void> => {
    return new Promise((resolve, reject) => {
      const width = 500;
      const height = 700;
      const left = window.screenX + (window.outerWidth - width) / 2;
      const top = window.screenY + (window.outerHeight - height) / 2.5;
  
      const popup = window.open(
        keycloak.createLoginUrl({ scope: 'openid' }),
        'KeycloakLogin',
        `width=${width},height=${height},left=${left},top=${top}`
      );
  
      const checkPopup = setInterval(() => {
        if (!popup || popup.closed) {
          clearInterval(checkPopup);
          reject(new Error('Login popup was closed'));
        }
  
        try {
          const currentUrl = popup?.location?.href;
          if (currentUrl && currentUrl.includes('code=') && currentUrl.includes('session_state=')) {
            clearInterval(checkPopup);
            popup?.close();
            resolve();
          }
        } catch (e) {
          // Cross-origin access will throw an error, which we can safely ignore
        }
      }, 100);
    });
  }
  const checkLoginState = useCallback(async () => {
    try {
      await keycloak.updateToken(5);
      if (keycloak.authenticated) {
        onLoginSuccess();
      }
    } catch (error) {
      console.error('Failed to update token:', error);
    }
  }, [keycloak, onLoginSuccess]);
  
  const handleLogin = async () => {
    setIsLoggingIn(true);
    try {
      await openKeycloakPopup(keycloak);
      
      // Check if the user is authenticated after the popup closes
      if (keycloak.authenticated) {
        console.log('User authenticated successfully');
        onLoginSuccess();
      } else {
        // If not authenticated, try to login again (this should use the existing session)
        await keycloak.login({prompt: 'none'});
        
        if (keycloak.authenticated) {
          console.log('User authenticated successfully after second check');
          onLoginSuccess();
        } else {
          console.error('Login failed: User not authenticated after popup closed');
          // You might want to show an error message to the user here
        }
      }
      
      // Force a reload of the page to ensure all components update
      window.location.reload();
    } catch (error) {
      console.error('Login failed:', error);
      // Handle login failure (e.g., show error message)
    } finally {
      setIsLoggingIn(false);
    }
  };
  return (
    <div className="screen login-screen bg-background">
      <div className="flex w-full items-center">
        <div className="flex w-full flex-col">
          <div className="container mx-auto px-10">
            <h1 className="font-serif uppercase text-white pb-20">Fort Knox</h1>
          </div>
          <div className="container mx-auto px-4">
            <div className="flex flex-col gap-4 md:flex-row">
              <div className="flex flex-1 items-center pl-60 pt-10 md:flex-row-reverse md:pb-20">
                <div className="lg:pr-[20%] w-full">
                <button 
                    onClick={handleLogin} 
                    className="bg-secondary text-white px-4 py-2 rounded"
                    disabled={isLoggingIn}
                  >
                    {isLoggingIn ? 'Logging in...' : 'Login with Keycloak'}
                  </button>
                  {/* {!showOTPInput ? (
                    <LoginForm onSubmit={onLoginFormSubmit} />
                  ) : (
                    <OTPForm onSubmit={onOTPSubmit} />
                  )} */}
                </div>
              </div>
              <div className="flex flex-1">
              <div className="flex items-end justify-between h-full w-[80%] pl-[10%]">
                {[...Array(13)].map((_, i) => (
                  <div key={i} className="w-8 bg-secondary mx-1" style={{ height: `${70 + Math.random() * 30}%` }}></div>
                ))}
              </div>
            </div>
            </div>
          </div>
          <div className="h-1.5 w-full bg-primary"></div>
          <div className="container mx-auto pr-[10%]">
            <div className="flex flex-row-reverse">
              <div>
                <h3 className="py-4 uppercase text-white">
                  gas consumption monitoring
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute bottom-6 flex w-full flex-row-reverse pr-6">
        <div className="kutir-logo-container flex bg-white p-2 rounded">
          <img src={kutirLogo} alt="" style={{width: 200}}/>
        </div>
      </div>
    </div>
  )
}
